<template>
  <div class="dashboardTop">
    <div class="left">
      <div class="dropdown-dashboard">
        <div class="container">
          <div class="head">{{ $t('dbm.selectDatabaseType') }} :</div>
          <RexSelectV3
            :showSearch="true"
            :options="getDatabaseList"
            :value="selectDBTypeLabel"
            :objectValueIndex="AppObjectIndex"
            :customStyle="{ width: '14.875rem' }"
            @onChange="selectDBType"
            :boldActive="boldActive"
            :filterOption="filterOption"
            id="search-select-database-type"
          />
        </div>
      </div>
      <div class="dropdown-dashboard ml-4">
        <RexInfiniteScrollDropdown
          :showSearch="true"
          :value="selectedOption"
          :options="databaseServicesTotal"
          id="search-select-database-service"
          :loading="isServicesLoading"
          :total="servicesTotalPages"
          :objectValueIndex="AppObjectIndex"
          :customStyle="{ width: '14.875rem' }"
          @onDropdownVisibleChange="onOpenSelectField"
          @onPopupScroll="scrollDBServices"
          :heading="selectServiceCluster"
          @onSearch="searchDBServices"
          :boldActive="boldActive"
          @onChange="selectDBService"
        />
      </div>
      <div
        class="dropdown-dashboard ml-4"
        v-if="getCurrentDatabase.key === MYSQL && currentCluster"
      >
        <RexInfiniteScrollDropdown
          :showSearch="true"
          :value="selectedCluster"
          :options="databaseClustersTotal"
          id="search-select-database-service"
          :loading="isClustersLoading"
          :total="clustersTotalPages"
          :objectValueIndex="AppObjectIndex"
          :customStyle="{ width: '14.875rem' }"
          @onDropdownVisibleChange="onOpenSelectClusters"
          @onPopupScroll="scrollDBClusters"
          @onSearch="searchDBClusters"
          :boldActive="boldActive"
          :heading="$t('dbm.header.selectCluster')"
          @onChange="selectDBCluster"
        />
      </div>
      <div
        class="dropdown-dashboard ml-4"
        v-if="getCurrentDatabase.key === MYSQL && displayInstance"
      >
        <RexInfiniteScrollDropdown
          :showSearch="true"
          :value="selectedInstance"
          :options="databaseInstances"
          id="search-select-database-instance"
          :customStyle="{ width: '14.875rem' }"
          :heading="selectDatabseCluster"
          @onChange="selectInstances"
        />
      </div>
      <div
        class="dropdown-dashboard ml-4"
        v-else-if="getCurrentDatabase.key !== MYSQL && displayInstance"
      >
        <RexInfiniteScrollDropdown
          :showSearch="true"
          :value="selectedInstance"
          :options="databaseInstancesTotal"
          id="search-select-database-instance"
          :loading="isInstancesLoading"
          :customStyle="{ width: '14.875rem' }"
          @onDropdownVisibleChange="onOpenSelectInstances"
          @onPopupScroll="scrollDBInstances"
          @onSearch="searchDBInstances"
          :heading="selectDatabseCluster"
          :boldActive="boldActive"
          @onChange="selectDBInstance"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DatabaseTypes from '@/utils/databaseTypes';
import { parseServiceObjFromApplication } from '@/utils/helper-function';
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import * as types from '@/components/Database/database.types';
import * as constants from '@/utils/templates/databaseTemplate/database.constants';
import RexInfiniteScrollDropdown from '@/rex-components/RexInfiniteScrollDropdown.vue';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import { PAGE_SIZE_SCROLL } from '@/utils/constants';
import { permissionTypes } from '@/router/constant';
import { notificationError } from '@/utils/notification';

export default {
  components: {
    RexInfiniteScrollDropdown,
    RexSelectV3,
  },
  data() {
    return {
      databaseList: DatabaseTypes,
      AppObjectIndex: 1,
      boldActive: true,
      POSTGRES: types.DatabaseTypes.pg,
      CASSANDRA: types.DatabaseTypes.ca,
      ORACLE: types.DatabaseTypes.or,
      COUCHBASE: types.DatabaseTypes.cb,
      MYSQL: types.DatabaseTypes.my,
      isServicesLoading: false,
      isInstancesLoading: false,
      isClustersLoading: false,
      servicesTotalPages: 0,
      servicesCurrentPage: 1,
      instancesTotalPages: 0,
      instancesCurrentPage: 1,
      clustersTotalPages: 0,
      clustersCurrentPage: 1,
      searchDBService: '',
      searchDBInstance: '',
      searchDBCluster: '',
      selectedOption: '',
      selectedInstance: '',
      selectedCluster: '',
      databaseServicesTotal: [],
      databaseInstancesTotal: [],
      databaseClustersTotal: [],
    };
  },
  computed: {
    active() {
      return true;
    },
    ...mapState('databaseState/databaseCommonState', [
      'currentDatabaseType',
      'currentDatabaseService',
    ]),
    ...mapState('globalState', ['app']),
    ...mapGetters('databaseState/databaseCommonState', [
      'getCurrentDatabase',
      'getCurrentDatabaseService',
    ]),
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    ...mapGetters('databaseState/detail', ['getCurrentSubType']),
    ...mapState('databaseState/detail', [
      'currentDatabaseInstance',
      'currentSubType',
      'databaseInstances',
      'currentCluster',
      'clusters',
    ]),
    selectDatabaseList() {
      return this.databaseList;
    },
    selectDBTypeLabel() {
      return this.getCurrentDatabase?.label ?? '';
    },
    selectServiceCluster() {
      if (this.getCurrentDatabase?.key === types.DatabaseTypes.cb) {
        return this.$t('dbm.header.selectCluster');
      } else {
        return this.$t('dbm.header.selectService');
      }
    },
    selectDatabseCluster() {
      if (
        this.getCurrentDatabase?.key === types.DatabaseTypes.cb ||
        this.getCurrentDatabase?.key === types.DatabaseTypes.my
      ) {
        return this.$t('dbm.header.selectNode');
      } else {
        return this.$t('dbm.header.selectDatabase');
      }
    },
    dropdownWidth() {
      if (
        this.getCurrentDatabase?.key === types.DatabaseTypes.my &&
        this.currentCluster?.key
      ) {
        return '10.9rem';
      } else {
        return '14.875rem';
      }
    },
    displayInstance() {
      return (
        this.getCurrentDatabase?.key === this.POSTGRES ||
        this.getCurrentDatabase?.key === this.CASSANDRA ||
        this.getCurrentDatabase?.key === this.ORACLE ||
        this.getCurrentDatabase?.key === this.MYSQL ||
        this.getCurrentDatabase?.key === types.DatabaseTypes.ms ||
        this.getCurrentDatabase?.key === types.DatabaseTypes.mg ||
        (this.getCurrentDatabase?.key === this.COUCHBASE &&
          (!this.currentSubType?.key === constants.SUB_TYPES.CB_CLUSTER ||
            this.currentSubType?.key === constants.SUB_TYPES.CB_NODE ||
            this.currentSubType?.key === constants.SUB_TYPES.CB_QUERIES ||
            this.currentSubType?.key === constants.SUB_TYPES.CB_BUCKET))
      );
    },
    getDatabaseList() {
      return this.databaseList.map((obj) => ({
        label: obj?.label,
        value: obj?.key,
      }));
    },
  },
  methods: {
    ...mapMutations('databaseState/databaseCommonState', [
      'setCurrentDatabaseType',
      'setDatabaseServices',
      'setCurrentDatabaseService',
    ]),
    ...mapMutations('databaseState/detail', [
      'setCurrentSubType',
      'setCurrentCluster',
    ]),
    ...mapActions('databaseState/databaseCommonState', ['getDatabaseServices']),
    ...mapMutations('databaseState/detail', [
      'setCurrentDatabaseInstance',
      'setDatabaseInstances',
      'setCurrentCluster',
      'setClusters',
    ]),
    ...mapActions('databaseState/detail', [
      'getDatabaseInstances',
      'getClusterDetails',
      'getInstancesByMetaPropertyWithTotal',
    ]),
    async fetchDatabaseInstances() {
      let databaseInstance = {
        duration: this.getDurationTime,
        serviceId: this.currentDatabaseService.key ?? '',
        properties: [
          {
            key: 'instance_type',
            value: types.instanceMapping[this.getCurrentDatabase.key],
          },
        ],
        keyword: this.searchDBInstance || '',
        pagination: {
          pageNum: this.instancesCurrentPage,
          pageSize: PAGE_SIZE_SCROLL,
          needTotal: true,
        },
      };
      if (this.getCurrentDatabase.key === types.DatabaseTypes.my) {
        databaseInstance.properties.push({
          key: 'clusterName',
          value: this.currentCluster.key ? this.currentCluster.label : '',
        });
      }
      return this.getDatabaseInstances(databaseInstance).catch((err) =>
        console.log(err),
      );
    },
    async fetchDatabaseInstancesByMetaProperties() {
      let databaseInstance = {
        duration: this.getDurationTime,
        serviceId: this.currentDatabaseService.key,
        keyword: this.searchDBInstance || '',
        pagination: {
          pageNum: this.instancesCurrentPage,
          pageSize: PAGE_SIZE_SCROLL,
          needTotal: true,
        },
      };
      if (this.currentDatabaseService && this.currentDatabaseService.key) {
        if (this.currentSubType.key === constants.SUB_TYPES.CB_CLUSTER) {
          databaseInstance.properties = [
            {
              key: 'metaProperty3',
              value: constants.CLUSTER,
            },
          ];
        } else {
          databaseInstance.properties = [
            {
              key: 'metaProperty3',
              value: constants.NODE,
            },
          ];
        }
        return this.getInstancesByMetaPropertyWithTotal(databaseInstance).catch(
          (err) => console.log(err),
        );
      }
    },
    onInstanceChange(option) {
      this.setCurrentDatabaseInstance(option);
    },
    onClusterChange(option) {
      this.setCurrentCluster(option);
    },
    onDatabaseChange(option) {
      this.setCurrentDatabaseType(option);
    },
    async fetchDatabaseServices() {
      return this.getDatabaseServices({
        duration: this.getDurationTime,
        serviceReq: {
          capability: 'D',
          subType: this.currentDatabaseType.key,
        },
        keyword: this.searchDBService || '',
        pagination: {
          pageNum: this.servicesCurrentPage,
          pageSize: PAGE_SIZE_SCROLL,
          needTotal: true,
        },
        permissions: [permissionTypes.READ, permissionTypes.WRITE],
      }).catch((err) => console.log(err));
    },
    setSubType(selectedTab) {
      let databaseTabs = this.app.currentSideNav.navTabs.find(
        (item) => item.activeTab === this.currentDatabaseType.key,
      );
      if (selectedTab)
        this.setCurrentSubType(
          databaseTabs?.tabs.find((subtype) => subtype.key === selectedTab),
        );
      else if (
        !databaseTabs?.tabs.find(
          (subtype) => subtype.key === this.getCurrentSubType.key,
        )
      )
        this.setCurrentSubType(databaseTabs?.tabs[0]);
    },
    async onOpenSelectField(open) {
      if (open && this.searchDBService) {
        this.servicesCurrentPage = 1;
        this.searchDBService = '';
        this.dbServicesData();
        this.isLoading = false;
      }
    },
    filterOption(input, option) {
      return option?.label
        ? option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        : false;
    },
    async dbServicesData(isSearch = false) {
      try {
        this.isServicesLoading = true;
        const { data } = await this.fetchDatabaseServices();
        const servicesData = data?.data?.services?.services;
        this.servicesTotalPages = data?.data?.services?.total;
        if (
          servicesData &&
          Array.isArray(servicesData) &&
          servicesData.length > 0
        ) {
          this.databaseServicesTotal =
            this.servicesCurrentPage === 1
              ? servicesData
              : [...this.databaseServicesTotal, ...servicesData];
          if (!this.selectedOption && !isSearch) {
            this.selectedOption =
              this.getCurrentDatabaseService?.label ||
              this.databaseServicesTotal[0]?.label;
            this.setCurrentDatabaseService(this.databaseServicesTotal[0]);
          }
        } else {
          this.databaseServicesTotal = [];
        }
        this.isServicesLoading = false;
      } catch (error) {
        console.log('error', error);
        this.isServicesLoading = false;
        this.databaseServicesTotal = [];
      }
    },
    scrollDBServices() {
      this.servicesCurrentPage += 1;
      this.dbServicesData();
    },
    searchDBServices(val) {
      this.servicesCurrentPage = 1;
      this.searchDBService = val;
      this.dbServicesData(true);
    },
    selectDBService(value, option) {
      this.selectedOption = value;
      const key = option.key?.split('-')?.[0];
      const selectedInstance = {
        key,
        label: option?.value,
        permissions: option?.metaProperty?.permissions,
      };
      this.setCurrentDatabaseService(selectedInstance);
      if (this.searchDBService) {
        this.searchDBService = '';
        this.servicesCurrentPage = 1;
        this.dbServicesData();
      }
    },
    onOpenSelectInstances(open) {
      if (open && this.searchDBInstance) {
        this.instancesCurrentPage = 1;
        this.searchDBInstance = '';
        this.dbInstancesData();
        this.isInstancesLoading = false;
      }
    },
    async dbInstancesData(isSearch = false) {
      try {
        this.isInstancesLoading = true;
        let { data } = [];
        if (this.getCurrentDatabase.key === types.DatabaseTypes.cb) {
          data = await this.fetchDatabaseInstancesByMetaProperties();
        } else {
          data = await this.fetchDatabaseInstances();
        }
        const instancesData = data.data?.data?.instanceId?.serviceInstances;
        this.instancesTotalPages = data.data?.data?.instanceId?.total;
        if (instancesData && Array.isArray(instancesData)) {
          this.databaseInstancesTotal =
            this.instancesCurrentPage === 1
              ? instancesData
              : [...this.databaseInstancesTotal, ...instancesData];
          if (!this.selectedInstance && !isSearch) {
            this.selectedInstance =
              this.currentDatabaseInstance?.label ||
              this.databaseInstancesTotal[0]?.label;
          } else if (this.selectedInstance && !isSearch) {
            const isSelectedInstanceInDatabase =
              this.databaseInstancesTotal.some(
                (instance) => instance.label === this.selectedInstance,
              );
            if (!isSelectedInstanceInDatabase) {
              this.selectedInstance =
                this.currentDatabaseInstance?.label ||
                this.databaseInstancesTotal[0]?.label;
            }
          }
        } else {
          this.selectedInstance = '';
        }
        this.isInstancesLoading = false;
      } catch (error) {
        console.log('error', error);
        this.isInstancesLoading = false;
        this.databaseInstancesTotal = [];
      }
    },
    scrollDBInstances() {
      this.instancesCurrentPage += 1;
      this.dbInstancesData();
    },
    searchDBInstances(val) {
      this.instancesCurrentPage = 1;
      this.searchDBInstance = val;
      this.dbInstancesData(true);
    },
    selectDBInstance(value, option) {
      this.selectedInstance = value;
      const key = option.key?.split('-')?.[0];
      const selectInstance = {
        ...option.metaProperty,
        key,
        label: option?.value,
      };
      this.setCurrentDatabaseInstance(selectInstance);
      if (this.searchDBInstance) {
        this.searchDBInstance = '';
        this.instancesCurrentPage = 1;
        this.dbInstancesData();
      }
    },
    selectDBType(value, option) {
      const selectInstance = { key: option?.value, label: option?.label };
      this.setCurrentDatabaseType(selectInstance);
    },
    selectInstances(value, option) {
      this.selectedInstance = value;
      const key = option.key?.split('-')?.[0];
      const selectInstance = {
        ...option.metaProperty,
        key,
        label: option?.value,
      };
      this.setCurrentDatabaseInstance(selectInstance);
    },
    async onOpenSelectClusters(open) {
      if (open && this.searchDBCluster) {
        this.clustersCurrentPage = 1;
        this.searchDBCluster = '';
        this.dbClustersData();
        this.isClustersLoading = false;
      }
    },
    async fetchClusters() {
      let databaseCluster = {
        duration: this.getDurationTime,
        serviceId: this.currentDatabaseService.key,
      };
      if (this.currentDatabaseService?.key) {
        databaseCluster.properties = [
          {
            key: 'instance_type',
            value: constants.CLUSTER,
          },
        ];
        return this.getClusterDetails(databaseCluster);
      }
    },
    async dbClustersData(isSearch = false) {
      try {
        this.isClustersLoading = true;
        const { data } = await this.fetchClusters();
        if (!this.currentCluster?.key) this.dbInstancesData();
        const clustersData = data.data?.instanceId?.serviceInstances;
        this.clustersTotalPages = data?.data?.clusters?.total;
        if (clustersData && Array.isArray(clustersData)) {
          this.databaseClustersTotal =
            this.clustersCurrentPage === 1
              ? clustersData
              : [...this.databaseclustersTotal, ...clustersData];
          if (!this.selectedCluster && !isSearch) {
            this.selectedCluster =
              this.currentCluster?.label ||
              this.databaseClustersTotal[0]?.label;
          } else if (this.selectedCluster && !isSearch) {
            const isSelectedClusterInDatabase = this.databaseClustersTotal.some(
              (instance) => instance.label === this.selectedCluster,
            );
            if (!isSelectedClusterInDatabase) {
              this.selectedCluster =
                this.currentCluster?.label ||
                this.databaseClustersTotal[0]?.label;
            }
          }
        } else {
          this.selectedInstance = '';
        }
        this.isClustersLoading = false;
      } catch (error) {
        console.log('error', error);
        this.isClustersLoading = false;
        this.databaseClustersTotal = [];
      }
    },
    scrollDBClusters() {
      this.clustersCurrentPage += 1;
      this.dbClustersData();
    },
    searchDBClusters(val) {
      this.clustersCurrentPage = 1;
      this.searchDBCluster = val;
      this.dbClustersData(true);
    },
    selectDBCluster(value, option) {
      this.selectedCluster = value;
      const key = option.key?.split('-')?.[0];
      const selectCluster = {
        key,
        label: option?.value,
        permissions: option?.metaProperty?.permissions,
      };
      this.setCurrentDatabaseService(selectCluster);
      if (this.searchDBCluster) {
        this.searchDBCluster = '';
        this.clustersCurrentPage = 1;
        this.dbClustersData();
      }
    },
  },
  async mounted() {
    this.dbServicesData();
    this.selectedOption = this.getCurrentDatabaseService?.label;
    if (this.getCurrentDatabase.key === this.MYSQL && this.currentCluster) {
      this.dbClustersData();
    } else {
      this.dbInstancesData();
    }
  },
  watch: {
    currentDatabaseType(newValue, oldValue) {
      if (newValue.key != oldValue.key) {
        this.setDatabaseInstances([]);
        this.setCurrentDatabaseInstance({});
        this.setCurrentDatabaseService({});
        this.setDatabaseServices([]);
        this.setCurrentCluster({});
        this.setClusters([]);
        this.databaseServicesTotal = [];
        this.databaseClustersTotal = [];
        this.databaseInstancesTotal = [];
        this.servicesCurrentPage = 1;
        this.clustersCurrentPage = 1;
        this.instancesCurrentPage = 1;
        this.selectedOption = '';
        this.selectedInstance = '';
        this.selectedCluster = '';
        this.dbServicesData();
        this.dbInstancesData();
        this.dbClustersData();
        this.setSubType();
      }
    },
    currentDatabaseService(newValue, oldValue) {
      if (!newValue) {
        this.setCurrentDatabaseInstance({});
        this.setDatabaseInstances([]);
        this.setCurrentCluster({});
        this.setClusters([]);
        this.databaseServicesTotal = [];
        this.databaseClustersTotal = [];
        this.databaseInstancesTotal = [];
        this.clustersCurrentPage = 1;
        this.instancesCurrentPage = 1;
        this.dbServicesData();
      } else {
        this.selectedInstance = '';
        this.selectedCluster = '';
        if (this.getCurrentDatabase.key === this.MYSQL && this.currentCluster) {
          this.dbClustersData();
        } else {
          this.dbInstancesData();
        }
      }
    },
    getDurationTime() {
      this.databaseInstancesTotal = [];
      this.databaseClustersTotal = [];
      this.dbServicesData();
      this.dbInstancesData();
      this.dbClustersData();
    },
    currentSubType() {
      if (this.getCurrentDatabase.key === types.DatabaseTypes.cb) {
        this.dbInstancesData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboardTop {
  @include flex-center-justify(space-between);
  margin-right: 0.6235rem;
  border-bottom: 0.0625rem solid $line-separator;
  padding-bottom: 0.6875rem;
  min-height: 4rem;
}
.left {
  display: flex;
}
.dropdown-dashboard {
  margin-left: 0.1375rem;
  text-align: left;
}
.ml-4 {
  margin-left: 1.5rem;
}
.make-default {
  @include flex-center;
  margin-left: 1rem;
  color: $font-primary;
}
.pin-btn {
  border: none;
  background: none;
  @include svg-fill-pointer($color-brand-accent);
}
.heading {
  margin-top: 0.3rem;
  font-size: 1.25em;
  color: $color-white;
  font-family: $semi-bold;
  margin-right: 0.5625em;
}
.container-in {
  display: flex;
}
.container {
  display: flex;
  padding-right: 0rem;
  padding-left: 0rem;
}
.head {
  margin-top: 0.3rem;
  font-size: 1.25em;
  color: $color-white;
  font-family: $semi-bold;
  margin-right: 0.5625em;
}
</style>
